export const calculateAreaCoordinates = (points, width, height) => {
    if (!points || !width || !height) {
        return {
            left: 0,
            top: 0,
            height: 0,
            width: 0,
        };
    }

    const x1 = (points[0][0] / width) * 100;
    const x2 = (points[2][0] / width) * 100;
    const y1 = (points[0][1] / height) * 100;
    const y2 = (points[1][1] / height) * 100;

    return {
        left: x1,
        top: y1,
        height: y2 - y1,
        width: x2 - x1,
    };
};

export const stripRefMarkers = (text) => {
    if (!text) {
        return "";
    }
    return text.replace(/\[:ref:[^\]]+:\]/g, "");
};

export const truncateName = (name, maxLength = 50) => {
    if (!name) {
        return "";
    }

    if (name.length <= maxLength) {
        return name;
    }

    const truncatePoint = name.lastIndexOf(" ", maxLength);

    if (truncatePoint > maxLength - 10) {
        return name.substring(0, truncatePoint) + "...";
    }

    return name.substring(0, maxLength) + "...";
};
